/**
 * 竞品对比 API — GET /api/competitive。
 * 批 4 追加：moves 竞品异动端点（契约见 kickoff 02 §7，与预警引擎 AR3 同源）。
 */
import client from "./client";
import type { CompetitorComparison, CompetitiveMoves, CompetitiveSnapshot, PositionMetrics } from "../types";

/** 获取竞品对比列表（可按品牌筛选）。 */
export async function getCompetitiveComparison(
  brandId?: string,
): Promise<CompetitorComparison[]> {
  return client.get<unknown, CompetitorComparison[]>("/competitive", {
    params: brandId ? { brand_id: brandId } : undefined,
  });
}

/**
 * 获取竞品异动列表（days 默认 7；AR3 数据源，预警引擎与页面共用）。
 * 后端并行开发中；调用方需自行 try/catch 做优雅降级。
 */
export async function getCompetitiveMoves(
  brandId?: string,
  days = 7,
): Promise<CompetitiveMoves> {
  return client.get<unknown, CompetitiveMoves>("/competitive/moves", {
    params: { ...(brandId ? { brand_id: brandId } : {}), days },
  });
}

/**
 * 获取竞品对比快照（基线视图，单期即可展示；moves 为空时的降级内容）。
 * 端点异常时调用方自行 try/catch 降级，不红屏。
 */
export async function getCompetitiveSnapshot(
  brandId?: string,
  days = 30,
): Promise<CompetitiveSnapshot> {
  return client.get<unknown, CompetitiveSnapshot>("/competitive/snapshot", {
    params: { ...(brandId ? { brand_id: brandId } : {}), days },
  });
}

/**
 * 获取 Top1/Top3 占位率 + 情感占比（P1#21/#22，全量探测样本，品牌级）。
 * 指标可能为 null（无竞品/无样本）→ 调用方显示「—」；
 * 端点异常时调用方自行 try/catch 降级，不红屏。
 */
export async function getPositionMetrics(
  brandId: string,
): Promise<PositionMetrics> {
  return client.get<unknown, PositionMetrics>("/competitive/position-metrics", {
    params: { brand_id: brandId },
  });
}
